import { render } from "./AdministrationRoundList.vue?vue&type=template&id=2406bc9c"
import script from "./AdministrationRoundList.vue?vue&type=script&lang=js"
export * from "./AdministrationRoundList.vue?vue&type=script&lang=js"

import "./AdministrationRoundList.vue?vue&type=style&index=0&id=2406bc9c&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__